import "flowbite"
import "@hotwired/turbo-rails"

Turbo.session.drive = false

import '../controllers/public'
